import React, { useState } from "react";
import { FaRegTrashAlt,  FaEdit } from "react-icons/fa";
import {createSubFilter, updateSubFilter} from "../auth/apiCategory";
import { IoMdAddCircleOutline } from "react-icons/io";
import { MdAddLink, MdClearAll} from "react-icons/md";
import Accordion from 'react-bootstrap/Accordion'

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["pageAddSubFilters"]?.[key] || fallback;

const PageAddSubFilters = (props) => {
    const {
    infoSource,
    filters = [],
    token,
    loadFilters
    // clickSubmitEdit
    } = props;

  __setElakayInfoSource(infoSource);

const {
    getButtonTitle
    } = infoSource;

        let mp = 'm-0 p-1 h5'
    const [activeKey, setActiveKey] = useState(null);
    const [data, setData] = useState([])
    const [filter, setFilter]= useState({})
    const [keyFilter, setKeyFilter]= useState("")
    const [message, setMessage] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
     const [name, setName] = useState("");
    const {_id, subFilter = []} = filter
  // Add a new filter item

const addSubFilter = (id) => {
  setData(prev => [...prev, { fil_id: id }]);
};
 // Remove a filter item
  const removeSubFilter = (id) => {
    const updatedFilters = data.SubFilter.filter((sf, i) => sf.fil_id !== id);
    setData({ ...data, SubFilter: updatedFilters });
  };


  const submitCrSubFilter =e=> {
        e.preventDefault();

            setError("");
            setSuccess(false);
          createSubFilter(token, _id, {name}).then(data => {
              if (data.error) {
                  setError(data.error);
              } else { 
                loadFilters(token)
                setName("");
                setData([])
                setFilter({})
               
              }
          });
      };

  const submitUpSubFilter = (id, data) => {
          updateSubFilter(token, id, {keyFilter, subFilter: data}).then(data => {
              if (data.error) {
                  setError(data.error);
              } else {
                setName("");
                setData([])
                setFilter({})
                loadFilters(token)
              }
          });
      };

const addOrRemoveSubFilter = (id) => {
  setData(prev => {
    const count = prev.filter(item => String(item.fil_id) === String(id))?.length;

    if (count === 0) {
      // Première fois → on ajoute
      return [...prev, { fil_id: id }];
    } else if (count === 1) {
      // Deuxième fois → on supprime toutes les occurrences
      return prev.filter(item => String(item.fil_id) !== String(id));
    }
    return prev; // sécurité
  });
};

const mapIdsToSubFilters =(arr)=> {
  return arr?.map(id => ({ fil_id: id._id }));
}

const filterBySubFilter = (subFilters, items) => {
  // Étape 1 : garder les items qui matchent
  const matchedItems = items.filter(item =>
    subFilters.some(sf => String(sf.fil_id) === String(item._id))
  );

  // Étape 2 : trouver les subFilters qui n’ont pas de correspondance
  const notFound = subFilters.filter(sf =>
    !items.some(item => String(item._id) === String(sf.fil_id))
  );

  // Étape 3 : fusionner les deux
  return [...matchedItems, ...notFound];
};

const filterBySubFilterNot= (subFilters, items) => {
  return items.filter(item =>
    subFilters.some(sf => String(sf.fil_id) === String(item._id))
  );
}

const hasMissingSubFilter = (result= []) => {
  // Vérifie si au moins un élément du résultat vient de subFilters uniquement
  return result.some(el => el.fil_id && !el._id);
};

const isIdInSubFilter =(subFilters, id) => {
  return subFilters.some(sf => String(sf.fil_id) === String(id));
}
  const selectFilter = (o)=>{
    const getSubFiltersByKey = (state =[], key) => {
  return state.find(b => String(b.keyFilter) === String(key))?.subFilter ?? [];
};
    setFilter(o)
    setData(getSubFiltersByKey(o.subFilter, keyFilter))
  }

  const handleChange = e => {
        setError('');
        setName(e.target.value);
    };

const isObjectInSubFilters = (subFilters, obj) => {
  return subFilters.some(sf => 
    Object.keys(obj).every(key => String(sf[key]) === String(obj[key]))
  );
};


         const isNullOrEmpty = (value)=> {
                // Check for null, undefined, or false
                if (value == null || value === false || value === undefined) return true;
            
                // Check if the value is an empty object or array
                if (typeof value === 'object') {
                    return Object.keys(value)?.length === 0;
                }
                // Otherwise, return false (the value is neither null, undefined, false, nor empty)
                return false;
            }

    const showSuccess = () => {
        if (success) {
            return <div className="alert alert-info" style={{ display: message ? "" : "none" }}> {message} </div>;
        }
    };

    const showError = () => {
        if (error) {
            return <div className="alert alert-danger" style={{ display: error ? "" : "none" }}> {error} </div>;
        }
    };


  const categorySeletedALL = (a =[], fo, va ) => (
    <div>
       
        <div className="boxCategory  mt-2">
            <div className="container">
<div className="itemCategory row ">
 
</div></div>
            {a && a?.map((c, i) => (
             <form key={i} className="container">
                    <div className="itemCategory row ">
                    <div className= {`col col-lg-2 Cacol ${va.ca}`} >
                            <input
                                onChange={()=> addOrRemoveSubFilter(c._id)}
                                value={c._id}
                                checked={isIdInSubFilter(data, c._id) ? "checked" : ''}
                                type="checkbox"
                                className="form-check-input inputCategory"
                                name="listName"
                                id={c._id+ "_"+ c.name}
                                />
                            <label className="form-check-label"  htmlFor={c._id+ "_"+ c.name}></label>
                    </div>
                        <div className={`col col-lg-6 Cacol ${va.ca}`}>
                            <p  className={isIdInSubFilter(data, c._id) ? "text-primary h5 m-0 p-1" : "m-0 p-1 h5"}>
                               {c.name} 
                            </p>

                        </div>
                    </div>
                    <input className="inputCategory" type="hidden" name="listName" value=""></input>
                    </form>
            ))}
        </div>

    </div>
)

    const CategoryFom = (obj=[]) => (
        <div>
            <div className="boxCategory1 mt-2" id="heading">

                <h2 className="text-primary h3 m-0 p-1"> 
                    {/* Filters Elakay  */}{__elakayText("t008", "+ sub")}{infoSource.language(infoSource, "title", "filter")}{__elakayText("t011", "for")}{filter.name}
                    </h2>
                {showSuccess()}
                {showError()}
            </div>

            <div className="boxCategory">

                {obj?.map((c, i) => (
                    <form className="container" key={i} >
                        <div className="itemCategory row">
                            <div className="col col-lg-7 Cacol">
                              <h5 >
                                    {c.name}
                                </h5>
                            </div>
                        </div>
                        <input className="inputCategory" type="hidden" name="listName" value=""></input>
                         
                    </form>
                ))}
         
                    <form className="itemCategory" onSubmit={submitCrSubFilter}>
                        <input
                            onBlur={() => setMessage("")}
                            className="inputCategory"
                            type="text"
                            placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pageAddSubFilters.t001}
                            onChange={handleChange}
                            value={name}
                            autoFocus
                            required
                        />
                        <button  
                        className="AddCategory"
                        data-toggle="tooltip" data-placement="top" title={getButtonTitle("submit")} 
                        >+</button>
                    </form>
            
            
            </div>

        </div>
    )

const subFiltersAndSelected = ()=>{

     return <>  {<div className="row mt-2">
           <h2 className="text-primary h4 m-0 mb-3">{__elakayText("t012", "Link")}{infoSource.language(infoSource, "title", "filter")}{__elakayText("t011", "for")}{filter.name} {keyFilter}{__elakayText("t009", "as sub Filter")}</h2>
   <div className="col col-12 col-md-6 col-lg-6 mt-3" >
        <h2 className="text-dark h5 m-0 p-0" >{filter.name} {keyFilter}{__elakayText("t010", "sub Filter")}</h2>
           { listeFilter(filterBySubFilter(data, filters))} 
          {hasMissingSubFilter(filterBySubFilter(data, filters)) && <h1 className="float-left rounded-4 bt-0" onClick={()=>setData(mapIdsToSubFilters(filterBySubFilterNot(data, filters)))}> <MdClearAll /></h1>}
     </div>
        <div className="col col-12 col-md-6 col-lg-6 mt-3">
            <h2 className="text-dark h5 m-0 p-0">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pageAddSubFilters.t002}</h2>
            {categorySeletedALL(filters, {}, {} )}
      </div> 
   
      </div>}
      {/* {CategoryFom(filterBySubFilter(data, filters))} */}
      </>

}

  const listeFilter = (filters=[])=>{
             return  <div className="boxCategory mt-2 mb-1">
                
                    {filters?.map((c, i) => (
                        <form className="container" key={i} >
                            <div className="itemCategory row">
                                <div className="col col-lg-7 Cacol">
                                   <h5>
                                        {c.name}
                                    </h5>
                                </div>
                            </div>
                            <input className="inputCategory" type="hidden" name="listName" value=""></input>
                    
                            
                        </form>
                    ))} 
                   
                    </div>
  }



    const valuesFilter = (arr=[], id)=>{
   return arr && arr?.map((c, i) => ( <div  key={i} className="itemCategory row ">
                    <div  className= {`col col-lg-8`} >
                            <input
                                onChange={()=> setKeyFilter(c === keyFilter ? "" : c)}
                                value={c}
                                checked={keyFilter === c ? "checked" : ''}
                                type="radio"
                                className="form-check-input inputCategory"
                                name="listName"
                                id={id+ "_"+ c}
                                />
                            <label className="form-check-label h5"  htmlFor={id+ "_"+ c}> {c}</label>
                    
                            {/* <p  className={isObjectInSubFilters(data, { subFilter: id , valFilter: c})  ? "text-primary h5 m-0 p-1" : "m-0 p-1 h5"}>
                               
                            </p> */}

                        </div>
                        
                    </div>
                        ))
    }

const handleSelect = (eventKey) => {
    // Quand on change de panneau
    if (eventKey !== activeKey) {
      setKeyFilter(""); // reset
    }
    setActiveKey(eventKey);
  };

        const categorySeleted = (a =[], fo, va ) => (
          <div className="ml-4 mr-4 pl-4 pr-4">
            <h2 className="text-dark h4 mb-3 p-0">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pageAddSubFilters.t003}</h2>
              <div className="container">
   
            <Accordion activeKey={activeKey} onSelect={handleSelect}>   
              {a && a?.map((c, i) => (
              <>  
          <Accordion.Item  key={i} eventKey={c._id} >
                  
                      <Accordion.Header>
              <span className="h4 m-0 p-0">{c.name}</span> 
                      </Accordion.Header>
              
                              <Accordion.Body>
                          <div style={{overflow: "auto" }}>
                          <ul>
  
                          {valuesFilter(c.FilterItem, c._id)}
              
                         </ul>
            {keyFilter? 
            <button className="btn btn-dark float-right btn-md py-1 rounded-4" onClick={() => {selectFilter(c)}}><MdAddLink />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pageAddSubFilters.t004}</button>
            : 
            <button className="btn btn-dark float-right btn-md py-1 rounded-4" disabled><MdAddLink />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pageAddSubFilters.t005}</button>}
                          </div>
                              </Accordion.Body>
                      </Accordion.Item></>
              ))}</Accordion>
          </div>
          </div>
  )

  return (<>
 {isNullOrEmpty(filter) && <>
{ categorySeleted(filters)}
 </>} 
 {!isNullOrEmpty(filter) && subFiltersAndSelected()}

<button className="btn btn-outline-info float-left m-4 pt-2 pb-2 pr-3 pl-3 rounded-4" onClick={()=>{selectFilter({});setData([])}}>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pageAddSubFilters.t006}</button>
 <button className="btn btn-outline-info float-right m-4 pt-2 pb-2 pr-3 pl-3 rounded-4" onClick={()=>submitUpSubFilter(_id, data)}>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pageAddSubFilters.t007}</button>
 {/* { addSubFilters()} */}
  </> );

 
};

export default PageAddSubFilters;